







































































































































import { Component, Mixins } from "vue-property-decorator";
import HelperDinamicallyForm from "@/components/DinamicallyForm/HelperDinamicallyForm";
import productoModule from "@/store/modules/producto-module";
import { producto } from "@/shared/dtos/producto";
import { UtilsDate } from "@/utils/utils-date";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
import { ProductoAmazon } from "@/shared/dtos/productosAmazon/ProductoAmazon";
import TiendaOnlineClientesModule from "@/store/modules/TiendaOnlineClientes-module";
import { ImagenProducto } from "@/shared/dtos/productosAmazon/ImagenProducto";
import { DynamicChangeEventClass } from "@/components/DinamicallyForm/DynamicChangeEventClass";
import ProcesosProducto from "../procesos/Procesos_producto.vue";

@Component({
  components: {
    ProcesosProducto,
  },
})
export default class formulario extends Mixins(HelperDinamicallyForm) {
  public item_pantalla: any = new producto();
  public item_amazon: ProductoAmazon = new ProductoAmazon();
  public mainImage = "https://via.placeholder.com/500x500.png?text=Producto";

  public async OnCreated() {
    this.BotonGuardar = false;
    this.BotonClonar = false;
    if (this.getparamId().HayParametro) {
      await productoModule.getproducto(this.getparamId().Parametro);
      await TiendaOnlineClientesModule.getTiendaOnlineClientes(
        this.getparamId().Parametro
      );
      this.item_pantalla = productoModule.producto;

      this.item_amazon = TiendaOnlineClientesModule.TiendaOnlineClientes;
      this.mainImage = this.item_amazon.hiRes;
    }
    // Actualiza el campo "Ganado"
    this.item_pantalla.ganado =
      (this.item_pantalla.precio_vendido || 0) -
      (this.item_pantalla.coste_compra || 0);
    // Calcula el 50% de "total_retail" y lo asigna a "precio_venta"
    this.item_pantalla.precio_venta = Math.ceil(
      (this.item_pantalla.total_retail || 0) * 0.5
    );
    this.item_pantalla.item_pkg_weight = Math.ceil(
      this.item_pantalla.item_pkg_weight
    );

    //Para la clonacion automatica
    this.BasicElement = this.item_pantalla;
  }
  changeMainImage(image: ImagenProducto) {
    this.mainImage = image.hiRes;
  }

  // Descarga todas las imágenes
  async downloadAllImages(images: ImagenProducto[]) {
    for (const [index, image] of images.entries()) {
      // Personaliza el nombre del archivo
      const fileName = this.item_amazon.asin + `_${index + 1}.jpg`;

      // Realiza la descarga
      await this.downloadImage(image.hiRes, fileName);
    }
  }
  // Método para descargar una imagen
  async downloadImage(url: string, fileName: string) {
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      // Crea un enlace temporal para descargar la imagen
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();

      // Libera el objeto URL
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error al descargar la imagen:", error);
    }
  }

  get mostrarCamposCoste() {
    this.SetFormItem("ganado").visible =
      ocultarcamposModule.mostrar_campos_coste;
    this.SetFormItem("coste_compra").visible =
      ocultarcamposModule.mostrar_campos_coste;
    return ocultarcamposModule.mostrar_campos_coste;
  }

  actualizar_vendido(e: DynamicChangeEventClass) {
    this.SetFormItem("ganado").data = (
      e.NewValue - Number.parseFloat(this.GetDataItem("coste_compra"))
    ).toFixed(2);
  }

  CreateNameTabs() {
    this.AddTabName("Datos Basicos");
    this.AddTabName("Datos Adicionales");
    this.AddTabName("Imágenes");
    this.AddTabName("Procesos del producto");
  }

  public TabDatosbasicos() {
    this.AddFormItemDataDefaultSlot(
      undefined,
      "Producto",
      "a_prodcuto",
      20
    ).Dimesiones(12, 12, 12);
    this.AddFormItemDataDefaultString(
      this.item_pantalla.item_desc,
      "Nombre del producto",
      "item_desc",
      255
    ).Dimesiones(12, 12, 12);
    this.AddFormItemDataDefaultString(
      this.item_amazon.descripcion,
      "Descripcion del producto",
      "descripcion",
      255
    )
      .Dimesiones(12, 12, 12)
      .CreateTextArea();
    this.AddFormItemDataDefaultSlot(
      this.item_amazon,
      "Imagenes",
      "imagenes",
      20,
      3
    ).Dimesiones(12, 12, 12);

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.item_pkg_weight,
      "Peso (Gramos)",
      "item_pkg_weight"
    ).Dimesiones(12, 6, 4);
    this.AddFormItemDataDefaultString(
      this.item_pantalla.lpn,
      "LPN",
      "lpn",
      60
    ).Dimesiones(12, 6, 4);
    this.AddFormItemDataDefaultSlot(
      undefined,
      "Más datos",
      "a_mas",
      20
    ).Dimesiones(12, 12, 12);
    this.AddFormItemDataDefaultString(
      this.item_pantalla.link_amazon,
      "Enlace de Amazon",
      "link_amazon",
      255
    ).Dimesiones(10, 10, 10).icon = "fab fa-amazon";

    this.AddFormItemDataDefaultSlot(
      this.item_pantalla.link_amazon,
      "btnlink_amazon",
      "btnlink_amazon",
      255
    ).Dimesiones(2, 2, 2);
    this.AddFormItemDataDefaultSlot(
      undefined,
      "Precios",
      "a_precios",
      20
    ).Dimesiones(12, 12, 12);

    /* Campo: Precio Venta (calculado) */
    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.precio_venta,
      "Precio venta teorico",
      "precio_venta"
    )
      .Dimesiones(12, 6, 4)
      .isReadOnly();
    /* Campo: Precio Venta (calculado) */
    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.mayorPrecioDeventa,
      "Mayor precio venta",
      "mayorPrecioDeventa"
    )
      .Dimesiones(12, 6, 4)
      .isReadOnly();

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.total_retail,
      "Precio amazon en la compra",
      "unit_retail"
    )
      .Dimesiones(12, 6, 4)
      .isReadOnly();
    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.ultimo_precio_amazon,
      "Precio amazon hoy",
      "ultimo_precio_amazon"
    )
      .Dimesiones(12, 6, 4)
      .isReadOnly();

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.coste_compra,
      "Coste",
      "coste_compra"
    )
      .Dimesiones(12, 6, 4)
      .isReadOnly();

    this.AddFormItemDataDefaultSlot(
      undefined,
      "Más detalles",
      "a_detalles",
      20
    ).Dimesiones(12, 12, 12);
    this.AddFormItemDataDefaultString(
      this.item_pantalla.pkg_id,
      "Localización",
      "pkg_id"
    ).Dimesiones(12, 6, 4);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.condicion,
      "Condición",
      "condicion",
      60
    ).Dimesiones(12, 6, 4);
    /* Grupo: Detalles del Producto */
    this.AddFormItemDataDefaultString(
      this.item_pantalla.asin,
      "ASIN",
      "asin",
      60
    ).Dimesiones(12, 6, 4);

    this.AddFormItemDataDefaultSlot(
      undefined,
      "Venta del producto",
      "a_venta",
      20
    ).Dimesiones(12, 12, 12);

    /* Grupo: Información de Venta */
    this.AddFormItemDataDefaultBoolean(
      this.item_pantalla.vendido,
      "¿Vendido?",
      "vendido",
      1,
      "Ya está vendido",
      "Aún no está vendido"
    ).Dimesiones(12, 6, 2);

    /* Grupo: Enlace */

    /* Grupo: Enlace */
    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.precio_vendido,
      "Precio vendido",
      "precio_vendido"
    ).Dimesiones(12, 6, 2);
    /* Campo: Ganado (oculto) */
    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.ganado,
      "Ganado",
      "ganado"
    )
      .Dimesiones(12, 6, 1)
      .isVisible(this.mostrarCamposCoste);
    this.AddFormItemDataDefaultDate(
      new Date(this.item_pantalla.fecha_venta),
      "Fecha de venta",
      "fecha_venta"
    ).Dimesiones(12, 6, 2);
    this.AddFormItemDataDefaultSlot(
      undefined,
      "Procesos",
      "a_procesos",
      20,
      4
    ).Dimesiones(12, 12, 12);
  }

  public CreateFields() {
    //Empezamos a crear una pantalla
    //configuracion de la clonacion automatica

    this.TabDatosbasicos();
    /* Grupo: Identificación y Ubicación */
    this.AddFormItemDataDefaultString(
      this.item_pantalla.liquidator_vendor_code,
      "Código de vendedor",
      "liquidator_vendor_code",
      60,
      2
    )
      .isRequired()
      .Dimesiones(12, 6, 4);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.inventory_location,
      "Ubicación del inventario",
      "inventory_location",
      60,
      2
    )
      .isRequired()
      .Dimesiones(12, 6, 4);

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.iog,
      "IOG",
      "iog",
      2
    ).Dimesiones(12, 6, 4);

    /* Grupo: Información del Envío */

    this.AddFormItemDataDefaultDate(
      new Date(this.item_pantalla.shipment_closed),
      "Fecha de cierre del envío",
      "shipment_closed",
      2
    ).Dimesiones(12, 6, 4);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.bol,
      "BOL",
      "bol",
      60,
      2
    ).Dimesiones(12, 6, 4);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.carrier,
      "Transportista",
      "carrier",
      60,
      2
    ).Dimesiones(12, 6, 4);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.upc,
      "UPC",
      "upc",
      60,
      2
    ).Dimesiones(12, 6, 4);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.ean,
      "EAN",
      "ean",
      60,
      2
    ).Dimesiones(12, 6, 4);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.fcsku,
      "FCSKU",
      "fcsku",
      60,
      2
    ).Dimesiones(12, 6, 4);

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.qty,
      "Cantidad",
      "qty",
      2
    ).Dimesiones(12, 6, 4);

    /* Grupo: Costos */
    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.cost,
      "Costo",
      "cost",
      2
    ).Dimesiones(12, 6, 4);

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.total_cost,
      "Costo total",
      "total_cost",
      2
    ).Dimesiones(12, 6, 4);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.currency_code,
      "Código de moneda",
      "currency_code",
      3,
      2
    ).Dimesiones(12, 6, 4);

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.id_pedido,
      "ID de pedido",
      "id_pedido",
      2
    ).Dimesiones(12, 6, 4);
  }

  public Insertar(object: producto) {
    productoModule.guardarproducto(object).then(() => {
      this.AllSaveOk();
    });
  }

  public Actualizar(object: producto) {
    productoModule.modificarproducto(object).then(() => {
      this.AllSaveOk();
    });
  }
}
